import {
  Button,
  createStyles,
  FormControl,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik } from "formik";
import React, { useState } from "react";
import useCollapse from "react-collapsed";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ChipCmp from "../../components/chip/chipCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import MultiSelectChip from "../../components/dropdown/MultiSelectChip";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { TABLE_FILTER, TABLE_FILTER_REGISTER } from "../../config/cacheKey";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  IDropDownRequest,
  IGetEnumsRequest,
  IResponse,
} from "../../models/dropdown.model";
import { FilterFinder, PaginationInfo } from "../../models/loan.model";
import { ISaleItemRequest } from "../../models/sale.model";
import {
  GetEnums,
  GetFinancialSuppliers,
  GetLoanTemplates,
  GetOrganizations,
} from "../../services/dropdown.service";

import {
  IfilterLoan,
  IGetLoansRequest,
  IGetLoansResponse,
} from "../../models/loanNew.Model";
import { GetLoans, GetLoansReportExcel } from "../../services/loan.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import "./facilitiesInProgress.css";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const columns: readonly ColumnModel[] = [
  { id: "customerName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "customerMobileNumber",
    label: "شماره همراه",
  },
  {
    id: "requestDatePersian",
    label: "تاریخ درخواست ",
  },
  {
    id: "loanRequestStatusTitle",
    label: "وضعیت",
  },
  {
    id: "loanTemplateTitle",
    label: "طرح تسهیلات",
  },
  {
    id: "organizationTitle",
    label: "سازمان",
  },

  {
    id: "amount",
    label: "مبلغ تسهیلات (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "stepSpaceByMonth",
    label: "فاصله اقساط",
  },
  {
    id: "installmentCount",
    label: "تعداد اقساط",
  },
  {
    id: "financialSupplierTitle",
    label: "تامین کننده مالی",
  },
  {
    id: "loanRequestStatusUpdateDatePersian",
    label: "تاریخ تغییر وضعیت ",
  },
];
let muiSelected: any;
export default function FacilitiesInProgress() {
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<IfilterLoan>();
  let row: any;
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  const oldPage = queryClient.getQueryData<FilterFinder>(TABLE_FILTER_REGISTER);
  const [isExpanded, setExpanded] = useState(true);
  const [data, setData] = useState<IGetLoansResponse[]>([]);
  const [valueCustomerNationalCode, setValueCustomerNationalCode] = useState<
    string
  >();
  const [valueCustomerName, setValueCustomerName] = useState<string>();
  const [valueCustomerMobileNumber, setValueCustomerMobileNumber] = useState<
    string
  >();
  const [loanTemplateId, setLoanTemplateId] = useState<any[]>([]);
  const [loanRequestStatusIds, setLoanRequestStatusIds] = useState<any[]>([]);
  const [orgnaizationId, setOrgnaizationId] = useState<any[]>([]);
  const [financialSupplierId, setFinancialSupplierId] = useState<any[]>([]);
  const [valueRequestDate, setValueRequestDate] = useState<string>();
  const [valueLastStatusChangeDate, setValueLastStatusChangeDate] = useState<
    string
  >();
  const [requestDate, setRequestDate] = useState<Date[] | null | undefined>(
    null
  );
  const [lastStatusChangeDate, setLastStatusChangeDate] = useState<
    Date[] | null | undefined
  >(null);

  const [selectedRow, setSelectedRow] = useState(undefined);

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  const [paymentDate, setPaymentDate] = React.useState<
    Date[] | null | undefined
  >(null);
  const [loanTemplateOption, setLoanTemplateOption] = React.useState<
    IResponse[]
  >([]);
  const [loanRequestStatusOption, setloanRequestStatusOption] = React.useState<
    IResponse[]
  >([]);
  const [orgnaizationOption, setOrgnaizationOption] = React.useState<
    IResponse[]
  >([]);
  const [fromStorage, setFromStorage] = React.useState<string>("");
  const [
    financialSupplierIdOption,
    setFinancialSupplierIdOption,
  ] = React.useState<IResponse[]>([]);
  React.useEffect(() => {
    let filterData: IfilterLoan;

    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER)!;
      if (filterData !== undefined && filterData !== null) {
        setValueCustomerName(filterData!.customerName!);
        setValueCustomerNationalCode(filterData!.customerName!);
        setValueCustomerMobileNumber(filterData!.customerMobileNumber!);
        setLoanRequestStatusIds(filterData!.loanRequestStatusIds!);
        setLoanTemplateId(filterData!.loanTemplateIds!);
        setOrgnaizationId(filterData!.orgnaizationIds!);
        setFinancialSupplierId(filterData!.financialSupplierIds!);
        setValueRequestDate("");
        setValueLastStatusChangeDate("");
      }
    } else {
      filterData = {} as IfilterLoan;
      filterData.customerName = "";
      filterData.customerNationalCode = "";
      filterData.customerMobileNumber = "";
      filterData.loanTemplateIds = [];
      filterData.loanRequestStatusIds = [];
      filterData.financialSupplierIds = [];
      // filterData.requestDatePersian = "";
      queryClient.setQueryData(TABLE_FILTER, null);
      setValueFilterData(filterData);
    }
    fillData(filterData!);
    const getDropDown = {} as IDropDownRequest;
    // getDropDown.title = "";
    GetLoanTemplatesMutate(getDropDown);
    GetOrganizationsMutate(getDropDown);
    const enums = {} as IGetEnumsRequest;
    enums.enumNames = ["LoanRequestStatus"];
    GetEnumsMutate(enums);
    GetFinancialSuppliersMutate(getDropDown);
  }, []);
  const { mutateAsync: GetLoansMutate } = useMutation(GetLoans, {
    onSuccess: (data: ApiResultModel<IGetLoansResponse[]>) => {
      setData(data.data);
      setPageInfo(data.pageInfo);
    },
  });

  const { mutateAsync: GetSalesByCustomerSearchExcelMutate } = useMutation(
    GetLoansReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );

  const { mutateAsync: GetEnumsMutate } = useMutation(GetEnums, {
    onSuccess: (data: IResponse[]) => {
      setloanRequestStatusOption(data);
    },
  });
  const { mutateAsync: GetLoanTemplatesMutate } = useMutation(
    GetLoanTemplates,
    {
      onSuccess: (data: IResponse[]) => {
        setLoanTemplateOption(data);
      },
    }
  );
  const { mutateAsync: GetOrganizationsMutate } = useMutation(
    GetOrganizations,
    {
      onSuccess: (data: IResponse[]) => {
        setOrgnaizationOption(data);
      },
    }
  );
  const { mutateAsync: GetFinancialSuppliersMutate } = useMutation(
    GetFinancialSuppliers,
    {
      onSuccess: (data: IResponse[]) => {
        setFinancialSupplierIdOption(data);
      },
    }
  );

  const setChildValueCustomerName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerName(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter.customerName = "";
    fillData(tabelFilter!);
  };
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter.customerNationalCode = "";
    fillData(tabelFilter!);
  };

  const setChildLoanRequestStatusIds = (childValues: any) => {
    const selectedItem = loanRequestStatusIds.filter(
      (item: any) => item !== childValues
    );
    setLoanRequestStatusIds(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.loanRequestStatusIds = tabelFilter!.loanRequestStatusIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildloanTemplateId = (childValues: any) => {
    const selectedItem = loanTemplateId.filter(
      (item: any) => item !== childValues
    );
    setLoanTemplateId(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildorgnaizationId = (childValues: any) => {
    const selectedItem = orgnaizationId.filter(
      (item: any) => item !== childValues
    );
    setOrgnaizationId(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.orgnaizationIds = tabelFilter!.orgnaizationIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildFinancialSupplier = (childValues: any) => {
    const selectedItem = financialSupplierId.filter(
      (item: any) => item !== childValues
    );
    setFinancialSupplierId(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.financialSupplierIds = tabelFilter!.financialSupplierIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter != undefined) tabelFilter!.customerMobileNumber = "";
    fillData(tabelFilter!);
  };
  const setChildValueRequestDate = (childValues: any) => {
    const selectedItem = "";
    setValueRequestDate(selectedItem);
    setRequestDate(undefined);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter != undefined) {
      tabelFilter!.requestDateFrom = undefined;
      tabelFilter!.requestDateTo = undefined;
      // tabelFilter!.requestDate = '';
    }

    fillData(tabelFilter!);
  };
  const setChildValueLastStatusChangeDate = (childValues: any) => {
    const selectedItem = "";
    setValueLastStatusChangeDate(selectedItem);
    setLastStatusChangeDate(undefined);
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    if (tabelFilter != undefined) {
      tabelFilter!.lastStatusChangeDateFrom = undefined;
      tabelFilter!.lastStatusChangeDateTo = undefined;
      // tabelFilter!.lastStatusChangeDate = '';
    }

    fillData(tabelFilter!);
  };

  const generateFilter = (filterData: IfilterLoan): IGetLoansRequest => {
    let request = {} as IGetLoansRequest;
    request.paginationInfo = currentPaginationInfo;
    // let storage = JSON.parse(
    //   localStorage.getItem(SALE_ITEM)!
    // ) as ISaleItemRequest | null;
    // if (storage?.ibans !== null && storage?.ibans !== undefined) {
    //   filterData = new Filter();
    //   filterData.ibans = [storage?.ibans];
    //   request.filter = filterData;
    //   return request;
    // }
    // if (storage?.branchId !== null && storage?.branchId !== undefined) {
    //   filterData = new Filter();
    //   filterData.branchIds = [storage?.branchId];
    //   request.filter = filterData;
    //   return request;
    // }
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: IfilterLoan) => {
    if (filterData === null || filterData === undefined) {
      filterData = {} as IfilterLoan;
      // filterData.customerName = "";
      // filterData.customerNationalCode = "";
      // filterData.customerMobileNumber = "";
      // filterData.requestDateFrom = "";
      // filterData.requestDateTo = "";
      // filterData.loanTemplateIds = [];
      // filterData.orgnaizationIds = [];
      // filterData.financialSupplierIds = [];
      // filterData.lastStatusChangeDateFrom = "";
      // filterData.lastStatusChangeDateTo = "";

      //add todo
    }
    let filter = generateFilter(filterData);
    GetLoansMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<IfilterLoan>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  // const handleChangeMultiselect = (
  //   event: SelectChangeEvent<typeof loanRequestOptions>
  // ) => {
  //   const {
  //     target: { value },
  //   } = event;
  // };
  //aaded go to stepper
  const dispatch = useDispatch();

  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_REGISTER
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }

  function changeValueCustomerName(e: any) {
    setValueCustomerName(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }

  function changeLoanRequestStatusIds(e: any) {
    setLoanRequestStatusIds(e);
  }
  function changeLoanTemplateId(e: any) {
    setLoanTemplateId(e);
  }
  function changeOrgnaizationId(e: number[]) {
    const selectedOrganizationTitles = e
      .map((organizationId) => {
        const organ = orgnaizationOption.find(
          (item) => item.id === organizationId
        );
        return organ ? organ.title : "";
      })
      .filter((title) => title !== "");
    // setSelectedIban(selectedOrganizationTitles);

    setOrgnaizationId(e);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeFinancialSupplier(e: any) {
    setFinancialSupplierId(e);
  }

  function changeRequestDate(e: any) {
    setRequestDate(e);
    setValueRequestDate(e.toString().replace(/,/g, " - "));
  }
  function changeValueLastStatusChangeDate(e: any) {
    setLastStatusChangeDate(e);
    setValueLastStatusChangeDate(e.toString().replace(/,/g, " - "));
  }
  function deleteChip() {
    setLoanRequestStatusIds([]);
    setLoanTemplateId([]);
    setOrgnaizationId([]);
    setFinancialSupplierId([]);
    setValueCustomerName("");
    setValueCustomerMobileNumber("");
    setValueCustomerNationalCode("");
    setValueRequestDate("");
    setValueLastStatusChangeDate("");
    setRequestDate([]);
    setLastStatusChangeDate([]);
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = {} as IfilterLoan;
  filter.loanRequestStatusIds = [];
  filter.loanTemplateIds = [];
  filter.orgnaizationIds = [];
  filter.financialSupplierIds = [];

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };
  const handelDetail = (
    saleKey: string,
    customerPersonId: number,
    branchId: number,
    rowIndex: number
  ) => {
    handleSelectRow(rowIndex);
    history.push({
      pathname: "/sale/saleFactorDetail",
      state: {
        from: "",
        id: branchId,
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
        saleKey: saleKey,
        branchId: branchId,
        customerPersonId: customerPersonId,
      },
    });
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetSalesByCustomerSearchExcelMutate(
      valueFilterData ? valueFilterData! : ({} as IfilterLoan)
    );
  };
  return (
    <div>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              if (
                requestDate != null &&
                (requestDate[0] != undefined || requestDate[1] != undefined)
              ) {
                values.requestDateFrom = convertToLocalDateTime(
                  Number(requestDate[0])
                );
                if (requestDate.length > 1) {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[1])
                  );
                } else {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[0])
                  );
                }
              } else {
                values.requestDateFrom = undefined;
                values.requestDateTo = undefined;
                values.requestDate = undefined;
              }
              if (
                lastStatusChangeDate != null &&
                (lastStatusChangeDate[0] != undefined ||
                  lastStatusChangeDate[1] != undefined)
              ) {
                values.lastStatusChangeDateFrom = convertToLocalDateTime(
                  Number(lastStatusChangeDate[0])
                );
                if (lastStatusChangeDate.length > 1) {
                  values.lastStatusChangeDateTo = convertToLocalDateTime(
                    Number(lastStatusChangeDate[1])
                  );
                } else {
                  values.lastStatusChangeDateTo = convertToLocalDateTime(
                    Number(lastStatusChangeDate[0])
                  );
                }
              } else {
                values.lastStatusChangeDateFrom = undefined;
                values.lastStatusChangeDateTo = undefined;
                values.LastStatusChangeDate = undefined;
              }
              // values.requestDatePersian = valueRequestDate;
              // values.requestDateArray = requestDate;
              queryClient.setQueryData(TABLE_FILTER, values);
              values.customerName = valueCustomerName;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerMobileNumber = valueCustomerMobileNumber;
              values.loanTemplateIds = loanTemplateId;
              values.loanRequestStatusIds = loanRequestStatusIds;
              values.orgnaizationIds = orgnaizationId;
              values.financialSupplierIds = financialSupplierId;
              values.RequestDate = valueRequestDate;
              values.lastStatusChangeDate = valueLastStatusChangeDate;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
              // changePageNumber(1);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className="shadowTextField"
                      helperText={""}
                      placeHolder={"متقاضی"}
                      label={"متقاضی "}
                      required={false}
                      value={valueCustomerName}
                      onChange={changeValueCustomerName}
                      name="customerName"
                      id="customerName"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                      type="number"
                      inputProps={{ maxLength: 10 }}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className="shadowTextField"
                      helperText={""}
                      placeHolder={"َشماره همراه"}
                      label={"َشماره همراه "}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name="customerMobileNumber"
                      id="customerMobileNumber"
                      type="tel"
                      inputProps={{ maxLength: 11 }}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={"وضعیت "}
                      value={loanRequestStatusIds}
                      onChange={changeLoanRequestStatusIds}
                      changeMultiSelect={changeLoanRequestStatusIds}
                      name="loanRequestStatusIds"
                      id="loanRequestStatusIds"
                      options={loanRequestStatusOption}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={" طرح تسهیلات "}
                      value={loanTemplateId}
                      onChange={changeLoanTemplateId}
                      changeMultiSelect={changeLoanTemplateId}
                      name="loanTemplateId"
                      id="loanTemplateId"
                      options={loanTemplateOption}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={" سازمان "}
                      value={orgnaizationId}
                      onChange={changeOrgnaizationId}
                      changeMultiSelect={changeOrgnaizationId}
                      name="orgnaizationId"
                      id="orgnaizationId"
                      options={orgnaizationOption}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={"تامین کننده مالی "}
                      value={financialSupplierId}
                      onChange={changeFinancialSupplier}
                      changeMultiSelect={changeFinancialSupplier}
                      name="financialSupplierId"
                      id="financialSupplierId"
                      options={financialSupplierIdOption}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={requestDate}
                        label={"تاریخ درخواست"}
                        onChange={changeRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={lastStatusChangeDate}
                        label={" تاریخ تغییر وضعیت تسهیلات"}
                        onChange={changeValueLastStatusChangeDate}
                        range={true}
                      />
                    </FormControl>
                  </div>

                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "30px" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueCustomerName ||
                valueCustomerNationalCode ||
                valueCustomerMobileNumber ||
                loanRequestStatusIds?.length ||
                loanTemplateId?.length ||
                orgnaizationId?.length ||
                financialSupplierId?.length ||
                valueRequestDate ||
                valueLastStatusChangeDate ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "20px" }}
                      >
                        <ChipCmp
                          item={valueCustomerName}
                          enamValue={valueCustomerName}
                          index={valueCustomerName?.length}
                          setChildValue={setChildValueCustomerName}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={loanRequestStatusIds}
                          enamValue={loanRequestStatusOption}
                          index={loanRequestStatusIds?.length}
                          setChildValue={setChildLoanRequestStatusIds}
                        />
                        <ChipCmp
                          item={loanTemplateId}
                          enamValue={loanTemplateOption}
                          index={loanTemplateId?.length}
                          setChildValue={setChildloanTemplateId}
                        />
                        <ChipCmp
                          item={orgnaizationId}
                          enamValue={orgnaizationOption}
                          index={orgnaizationId?.length}
                          setChildValue={setChildorgnaizationId}
                        />
                        <ChipCmp
                          item={financialSupplierId}
                          enamValue={financialSupplierIdOption}
                          index={financialSupplierId?.length}
                          setChildValue={setChildFinancialSupplier}
                        />
                        <ChipCmp
                          item={valueRequestDate}
                          enamValue={valueRequestDate}
                          index={valueRequestDate?.length}
                          setChildValue={setChildValueRequestDate}
                        />
                        <ChipCmp
                          item={valueLastStatusChangeDate}
                          enamValue={valueLastStatusChangeDate}
                          index={valueLastStatusChangeDate?.length}
                          setChildValue={setChildValueLastStatusChangeDate}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            {data.length > 0 ? (
              <TableBody
                style={{
                  height: "30px",
                  minHeight: "30px",
                }}
              >
                {data?.map((row, rowIndex) => {
                  return (
                    <TableRow
                      classes={{ root: classes.select }}
                      className={`${
                        rowIndex % 2 == 0
                          ? "rowTBodyE  borderRight borderLeft"
                          : "rowTBodyO  borderRight borderLeft"
                      }${classes} borderRight borderLeft  noWrap`}
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      // key={row.loanRequestId}
                      // selected={selectedRow === rowIndex}
                      onClick={
                        () => {}
                        // handelDetail(
                        //   row.saleKey,
                        //   row.customerPersonId,
                        //   row.branchId,
                        //   rowIndex
                        // )
                      }
                    >
                      <TableCell
                        className="textFont12"
                        style={{ width: "5px" }}
                      >
                        {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                          (currentPaginationInfo.pageSize! ?? 0) +
                          rowIndex +
                          1}
                      </TableCell>
                      {columns?.map((column) => {
                        const value = row[column.id as keyof IGetLoansResponse];
                        return (
                          <TableCell
                            className="textFont12 nowrapClass"
                            key={column.id}
                            align="right"
                          >
                            {column.format && column.hasFormat ? (
                              column.format(value)
                            ) : column.id === "saleStatusPersian" ? (
                              <b style={{ color: "#FB8C00" }}> {value}</b>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : null}
          </Table>
        </TableContainer>
        {data.length === 0 ? (
          <span
            className="emptyTable"
            style={{ color: "#C1C7CB", fontSize: "16px" }}
          >
            موردی یافت نشد.
          </span>
        ) : null}
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
